import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import DefaultDetail from "./DefaultDetail";
export default {
  inject: ['i18n'],
  components: {
    DefaultDetail: DefaultDetail
  },
  props: {
    model: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    users: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    authority: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    authorities: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    groups: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    onChange: {
      type: Function,
      default: function _default() {}
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      usersCopy: this.users,
      groupsCopy: this.groups,
      authoritiesCopy: this.authorities
    };
  },
  methods: {
    filterUsers: function filterUsers(input) {
      if (input) {
        this.usersCopy = this.users.filter(function (item) {
          if (item.name.indexOf(input) > -1) {
            return true;
          }
        });
      } else {
        this.usersCopy = this.users;
      }
    },
    filterAuthorities: function filterAuthorities(input) {
      if (input) {
        this.authoritiesCopy = this.authorities.filter(function (item) {
          console.log(item);
          if (item.name.indexOf(input) > -1) {
            return true;
          }
        });
      } else {
        this.authoritiesCopy = this.authorities;
      }
    },
    filterGroups: function filterGroups(input) {
      if (input) {
        this.groupsCopy = this.groups.filter(function (item) {
          if (!!~item.name.indexOf(input) || !!~item.name.toLowerCase().indexOf(input.toLowerCase())) {
            return true;
          }
        });
      } else {
        this.groupsCopy = this.groups;
      }
    }
  }
};